import { ROUTE_NAMES } from "@root/constants";
import DashboardLayout from "@root/layouts/DashboardLayout";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { FaqProvider } from "@root/context/faq-context";
import { MemberDetailsContextProvider } from "@root/context/member-detail-context";
import { ResourcesProvider } from "@root/context/resources-context";
import { LoginUser } from "@root/pages/auth/login/loginUser";
import { PledgeDashboardPage } from "@root/pages/dashboard/pledgeDashboard";
import ManageCourses from "@root/pages/dashboard/ManageCourses";
import { MembersListingPage } from "@root/pages/members-listing";
import { NotificationsPage } from "@root/pages/notifications";
import Notice from "@root/components/Notice/Index";
import JournalistManagment from "@root/components/journalist-managment/Index";
import { MyProfile } from "@root/pages/profilesection-journalist/myprofile";
import { UpdateProfile } from "@root/pages/profilesection-journalist/updateprofile/updateprofile";
import { JournalistProvider } from "@root/context/journalist-context";
import { SubscriberContextProvider } from "@root/context/use-subscriber-context";
import DepartmentManagement from "@root/components/departmentManagement";
import { DeptCategoryProvider } from "@root/context/pledge-deparments";
import SubsubscriberManagement from "@root/pages/sub-subsriber-management/sub-subscriber";
import { SubSubscriberContextProvider } from "@root/context/sub-subscriber";
import PledgeJournalistList from "@root/components/pledge-journalisr-list/index";

export const pledgingRoutes = createBrowserRouter([
  {
    path: "/",
    element: (
      <SubSubscriberContextProvider>
        <SubscriberContextProvider>
          <JournalistProvider>
            <MemberDetailsContextProvider>
              <ResourcesProvider>
                <FaqProvider>
                  <DeptCategoryProvider>
                    <DashboardLayout />
                  </DeptCategoryProvider>
                </FaqProvider>
              </ResourcesProvider>
            </MemberDetailsContextProvider>
          </JournalistProvider>
        </SubscriberContextProvider>
      </SubSubscriberContextProvider>
    ),
    children: [
      {
        path: "/",
        element: <Navigate to={ROUTE_NAMES.PLEDGE_DASHBOARD} />,
      },
      {
        path: ROUTE_NAMES.PLEDGE_DASHBOARD,
        element: <PledgeDashboardPage />,
      },
      {
        path: ROUTE_NAMES.PLEDGE_COURSES,
        element: <ManageCourses />,
      },
      {
        path: ROUTE_NAMES.PLEDGE_JOURNALIST_LIST,
        element: <PledgeJournalistList />,
      },
      {
        path: ROUTE_NAMES.PLEDGE_ALL_NOTICES,
        element: <Notice />,
      },
      {
        path: ROUTE_NAMES.PLEDGE_NOTIFICATIONS,
        element: <NotificationsPage />,
      },
      {
        path: ROUTE_NAMES.JOURNALIST_MANAGEMENT,
        element: <JournalistManagment />,
      },
      {
        path: ROUTE_NAMES.PLEDGE_PROFILE,
        element: <MyProfile />,
      },
      {
        path: ROUTE_NAMES.PLEDGE_UPDATE_PROFILE,
        element: <UpdateProfile />,
      },
      {
        path: ROUTE_NAMES.DEPARTMENT_MANAGEMENT,
        element: <DepartmentManagement />,
      },
      {
        path: ROUTE_NAMES.SUB_SUBSCRIBER_MANAGEMENT,
        element: <SubsubscriberManagement />,
      },
      {
        path: "*",
        element: <Navigate to={ROUTE_NAMES.PLEDGE_DASHBOARD} />,
      },
    ],
  },
]);
